export const quranDe = {
  landing: {
    badge: 'Der Koran ist jetzt für alle offen',
    titleLine1: 'Der Koran, für alle.',
    titleGradient: 'Lesen. Hören. Studieren.',
    subtitle:
      'Der ganze Koran auf Arabisch, mit Übersetzungen ins Deutsche, Niederländische, Französische, Englische und Bosnische. Kostenlos, ohne Anmeldung, auf jedem Gerät. Suche ein Wort, zähle es im ganzen Koran und höre Vers für Vers.',
    appNote: 'Für Hifz mit KI, Offline-Audio und Gebetszeiten hol dir die App.',
    daily: 'Vers des Tages',
    listen: 'Anhören',
    study: 'Diesen Vers studieren',
    studyEyebrow: 'Der Koran auf Deenly',
    studyTitle: 'Nicht nur lesen. Studieren.',
    studySubtitle: 'Werkzeuge, die dir helfen zu verstehen, was du liest, kostenlos für alle.',
    cards: [
      { to: '/quran/', icon: 'solar:book-2-linear', title: 'Lesen und hören', body: 'Alle 114 Suren, der arabische Text, Übersetzungen in fünf Sprachen und sechs Rezitatoren. Der Player folgt dem rezitierten Vers, sogar auf dem Sperrbildschirm.', cta: 'Koran öffnen' },
      { to: '/quran/tafsir/', icon: 'solar:notebook-bookmark-linear', title: 'Tafsir zu jedem Vers', body: 'Was bedeutet ein Vers? Eine Erklärung aller 6.236 Verse aus Al-Mukhtasar, auf Englisch, Französisch, Bosnisch und im arabischen Original, mit Quelle und Zitierhinweis.', cta: 'Tafsir öffnen' },
      { to: '/quran/search/', icon: 'solar:magnifer-linear', title: 'Nach Wort oder Bedeutung suchen', body: 'Finde einen Vers über ein Wort, den Namen einer Sure oder eine Angabe wie 2:255. Oder beschreibe ein Thema, und die KI findet Verse nach ihrer Bedeutung.', cta: 'Koran durchsuchen' },
      { to: '/quran/2/255/', icon: 'solar:square-academic-cap-linear', title: 'Wort für Wort', body: 'Tippe auf ein arabisches Wort: seine Wurzel, seine Grammatik und wie oft es im Koran vorkommt. Folge von der Wurzel aus einem Gedanken durch den ganzen Koran.', cta: 'Probier es mit Ayat al-Kursi' },
    ],
  },
  nav: {
    home: 'Deenly-Startseite',
    quran: 'Koran',
    label: 'Koran-Navigation',
    read: 'Lesen',
    search: 'Suche',
    words: 'Koran in Zahlen',
    tafsir: 'Tafsir',
    roots: 'Wurzeln',
    chronology: 'Chronologie',
    switchLanguage: 'Sprache wechseln',
  },
  common: {
    close: 'Schließen',
    error: 'Etwas ist schiefgelaufen. Bitte versuch es gleich noch einmal.',
    notFound: 'Diesen Vers gibt es nicht.',
    breadcrumbs: 'Brotkrümelnavigation',
    pagination: 'Zurück und weiter',
    loadMore: 'Mehr laden',
  },
  translation: {
    de: 'Deutsch · Bubenheim & Elyas',
    nl: 'Niederländisch · Rowwad Translation Center',
    fr: 'Französisch · Rachid Maach',
    bs: 'Bosnisch · Besim Korkut',
    en: 'Englisch · Saheeh International',
  },
  quick: {
    label: 'Am meisten gelesen',
    ayatulKursi: 'Ayat al-Kursi',
    lastOfBaqarah: 'Ende von Al-Baqara',
  },
  index: {
    badge: 'Für alle offen · kostenlos · ohne Anmeldung',
    title: 'Der Koran, für alle',
    subtitle:
      'Alle 114 Suren auf Arabisch, mit Übersetzungen ins Deutsche, Niederländische, Französische, Englische und Bosnische. Höre Vers für Vers, suche nach Wort oder Bedeutung und studiere jedes Wort.',
    stats: [
      { label: 'Suren', value: '114' },
      { label: 'Verse', value: '6.236' },
      { label: 'Sprachen', value: '6' },
      { label: 'Rezitatoren', value: '6' },
    ],
    wordsTitle: 'Wie oft sagt der Koran …?',
    wordsBody:
      'Gib ein beliebiges Wort ein (auf Deutsch, Arabisch, Englisch oder Bosnisch) und sieh in Sekunden, wie oft es vorkommt und in welchen Suren und Versen. Vergleiche zwei Wörter und entdecke den Koran aus einem neuen Blickwinkel.',
    wordsCta: 'Koran in Zahlen öffnen',
    surahsTitle: 'Alle Suren',
    surahsSubtitle: 'Finde eine Sure nach Name, Bedeutung oder Nummer.',
    filterLabel: 'Suren filtern',
    filterPlaceholder: 'z. B. Yasin, Die Höhle, 18…',
    filterRevelation: 'Ort der Offenbarung',
    filterAll: 'Alle',
    noMatch: 'Keine passende Sure.',
  },
  surah: {
    meccan: 'Mekkanisch',
    medinan: 'Medinensisch',
    ayahCount: '{n} Vers | {n} Verse',
    juz: 'Juz {n}',
    listen: 'Sure anhören',
    previous: 'Vorherige Sure',
    next: 'Nächste Sure',
  },
  ayah: {
    actions: 'Aktionen für {ref}',
    listen: '{ref} anhören',
    copy: 'Vers kopieren',
    save: 'In meinem Studienraum speichern',
    saved: 'In deiner Sammlung gespeichert',
    copied: 'Kopiert',
    share: 'Teilen',
    study: '{ref} studieren',
    sajdah: 'Sajdah',
  },
  ayahPage: {
    eyebrow: 'Vers',
    inContext: 'Im Zusammenhang lesen',
    listenOn: 'Von hier an hören',
    previous: 'Vorheriger Vers',
    next: 'Nächster Vers',
    wordsTitle: 'Wort für Wort',
    wordsHint: 'Jedes Wort des Verses mit Aussprache und Bedeutung. Tippe auf ein Wort, um zu sehen, wie oft es im Koran vorkommt.',
    wordsSource: 'Aussprache und Wortbedeutungen: Quran.com.',
    wordsSourceBs: 'Aussprache und Wortbedeutungen: Quran.com.',
    relatedTitle: 'Verwandte Verse',
    relatedHint: 'Verse an anderen Stellen des Korans, die vom selben Thema sprechen.',
    aboutSurah: 'Über diese Sure',
  },
  settings: {
    title: 'Einstellungen',
    translation: 'Übersetzung',
    both: 'Beide',
    none: 'Keine',
    arabicFont: 'Arabische Schrift',
    arabicSize: 'Größe des arabischen Textes',
    sizeStep: 'Größe {n}',
    wordStudy: 'Wortstudium',
    wordStudyHint: 'Tippe auf ein arabisches Wort, um zu sehen, wie oft es im Koran vorkommt.',
  },
  player: {
    label: 'Koran-Player',
    play: 'Abspielen',
    pause: 'Pause',
    previous: 'Vorheriger Vers',
    next: 'Nächster Vers',
    stop: 'Stoppen und schließen',
    expand: 'Player öffnen',
    collapse: 'Player verkleinern',
    nowPlaying: 'Wird gerade rezitiert',
    openSurah: 'Sure öffnen',
    seek: 'Position im Vers',
    failed: 'Das Audio wurde nicht geladen. Prüfe deine Verbindung und versuch es noch einmal.',
    reciter: 'Rezitator',
    repeatAll: 'Alles wiederholen',
    ayahRepeat: 'Jeden Vers wiederholen: {n}',
    repeatRound: '{n}. Mal',
    volume: 'Lautstärke',
    sleep: 'Schlaf-Timer',
    sleepMinutes: 'In {n} Minuten',
    sleepEnd: 'Am Ende der Sure',
    sleepOff: 'Timer ausschalten',
    tabText: 'Text',
    ayahOf: 'Vers {ayah} von {total}',
    backToCurrent: 'Zurück zum rezitierten Vers',
    speed: 'Geschwindigkeit',
    follow: 'Der Rezitation folgen',
    followHint: 'Während eine Sure läuft, scrollt die Seite von selbst zum rezitierten Vers und hebt ihn hervor.',
  },
  peek: {
    title: 'Das Wort {word} im Koran',
    eyebrow: 'Dieses Wort im Koran',
    exact: 'Genau diese Form',
    inside: 'In anderen Wörtern',
    spread: 'In {ayahs} Versen, verteilt auf {surahs} Suren.',
    open: 'Alle Vorkommen',
  },
  tafsir: {
    nav: 'Tafsir',
    cta: 'Tafsir öffnen',
    teaser: 'Was bedeutet ein Vers? Eine Erklärung zu jedem Vers aus Al-Mukhtasar, auf Englisch, Französisch, Bosnisch und im arabischen Original, mit Quelle und Zitierhinweis für dein Studium.',
    eyebrow: 'Den Koran erklären',
    title: 'Tafsir des Korans',
    intro:
      'Eine Erklärung zu jedem der 6.236 Verse aus Al-Mukhtasar, auf Englisch, Französisch, Bosnisch und im arabischen Original. Lies den Tafsir Sure für Sure, vergleiche ihn mit dem Original und suche, was er zu einem Thema sagt.',
    facts: { ayahs: 'erklärte Verse', langs: 'Sprachen: Englisch, Französisch, Niederländisch, Bosnisch, Arabisch', surahs: 'Suren' },
    surahsTitle: 'Tafsir nach Suren',
    surahsHint: 'Wähle eine Sure: jeder Vers auf Arabisch, mit Übersetzung und der Erklärung darunter.',
    aboutTitle: 'Über Al-Mukhtasar',
    about: [
      'Al-Mukhtasar zur Auslegung des edlen Korans wurde vom Tafsir-Zentrum für Koranstudien erarbeitet. Jeder Vers wird kurz und klar erklärt, ohne lange Abschweifungen. Das passt zum täglichen Lesen ebenso wie zum ernsthaften Studium.',
      'Verfasst wurde er auf Arabisch; die englische, französische und bosnische Fassung sind Übersetzungen dieses Originals. Deshalb kannst du bei jedem Vers das arabische Original öffnen und mit der Übersetzung vergleichen.',
    ],
    methodTitle: 'Wie er hier veröffentlicht wird',
    method: [
      'Der Text wird genau so veröffentlicht, wie ihn die Quelle herausgibt, ohne Änderungen oder Kürzungen.',
      'Jeder Text nennt Titel, Autor, Ausgabe und das Abrufdatum, und die Schaltfläche „Zitieren“ liefert ein fertiges Zitat mit Link.',
      'Der Tafsir wird auf dem Stand der neuesten Fassung von QuranEnc.com gehalten.',
    ],
    langLabel: 'Sprache des Tafsirs',
    langs: { bs: 'Bosanski', en: 'English', fr: 'Français', nl: 'Nederlands', ar: 'العربية' },
    sameAs: 'Siehe die Erläuterung zu Vers {n}.',
    retold: 'Eine moderne Nacherzählung nach den klassischen Gelehrten, keine wörtliche Übersetzung',
    translationOf: 'Aus dem arabischen Original übersetzt',
    original: 'Arabisches Original',
    label: 'Tafsir',
    ayahTitle: 'Tafsir zu diesem Vers',
    ayahHint: 'Was dieser Vers bedeutet: die Erklärung aus Al-Mukhtasar.',
    wholeSurah: 'Tafsir der ganzen Sure',
    readSurah: 'Sure lesen',
    show: 'Tafsir',
    hide: 'Tafsir ausblenden',
    toggle: 'Tafsir zu {ref}',
    inReader: 'Tafsir unter jedem Vers',
    inReaderHint: 'Eine kurze Erklärung unter jedem Vers. Die Schaltfläche „Tafsir“ an einem Vers öffnet sie einzeln.',
    showAyah: 'Vers und Übersetzung',
    ayahIndex: 'Verse',
    goToAyah: 'Zu Vers {n}',
    source: 'Quelle',
    sourceLine: '{title} — {author}. {publisher}, Ausgabe „{edition}“, abgerufen am {date}.',
    cite: 'Zitieren',
    cited: 'Zitat kopiert',
    refAyah: 'zu Vers {key}',
    refSurah: 'zu Sure {name}',
    citation: '{title} ({author}), Erklärung {ref}. {publisher}, Ausgabe „{edition}“, abgerufen am {date}. {url}',
    unavailable: 'Der Tafsir ist in dieser Sprache noch nicht verfügbar.',
    searchTitle: 'Tafsir durchsuchen',
    searchLabel: 'Tafsir durchsuchen',
    searchPlaceholder: 'Thema oder Wort, z. B. patience, parents, Day of Judgement',
    searchHint: 'Durchsucht die Erklärungen, nicht nur die Verse: So findest du, was der Tafsir zu einem Thema sagt. Suche in der Sprache des Tafsirs, zum Beispiel auf Englisch.',
    resultCount: 'Kein Vers enthält „{q}“ im Tafsir | {n} Vers enthält „{q}“ im Tafsir | {n} Verse enthalten „{q}“ im Tafsir',
    previous: 'Vorherige Sure',
    next: 'Nächste Sure',
  },
  opinions: {
    title: "Was die Gelehrten sagten",
    searchHint: "Antworten von Gelehrten der Ahl as-Sunnah, nach Wörtern und Bedeutung gefunden, jede mit Link zur Quelle.",
    ayahHint: "Antworten, die diese Aya anführen.",
    none: "Keine Antwort gefunden.",
    scholars: "Gelehrte",
    citedAyat: "Angeführte Ayat:",
    source: "An der Quelle lesen: {source}",
    inLanguage: "Verfügbar auf: {language}",
  },
  search: {
    title: 'Koran durchsuchen',
    label: 'Koran durchsuchen',
    placeholder: 'Ein Wort, eine Sure oder ein Vers (z. B. mercy, Yasin, 2:255)',
    submit: 'Suchen',
    suggestions: 'Vorschläge',
    jump: 'Zu Vers {ref}',
    allResults: 'Alle Ergebnisse für „{q}“',
    countWord: 'Wie oft wird „{q}“ erwähnt?',
    modeLabel: 'Suchmodus',
    byWords: 'Nach Wörtern',
    byMeaning: 'Nach Bedeutung',
    byScholars: "Gelehrte",
    byTafsir: 'Im Tafsir',
    meaningHint: 'Beschreibe ein Thema mit deinen eigenen Worten, z. B. „Verse über Geduld in schweren Zeiten“. Die KI findet Verse nach ihrer Bedeutung, nicht nach Stichwörtern.',
    meaningTooShort: 'Gib mindestens drei Buchstaben ein.',
    meaningError: 'Die Suche nach Bedeutung ist gerade nicht verfügbar. Versuch es mit der Suche nach Wörtern.',
    resultCount: 'Keine Verse für „{q}“ | {n} Vers für „{q}“ | {n} Verse für „{q}“',
    took: '{ms} ms',
    aiLabel: 'Künstliche Intelligenz',
    aiWorking: 'Die KI durchsucht den Koran nach Bedeutung…',
    aiFound: 'Die KI hat zu dieser Frage keinen Vers gefunden | Die KI hat {n} Vers nach Bedeutung gefunden | Die KI hat {n} Verse nach Bedeutung gefunden',
    emptyTitle: 'Was du suchen kannst',
    tips: [
      'Ein Wort auf Deutsch, Englisch, Bosnisch oder Arabisch: Barmherzigkeit, mercy, milost, رحمة',
      'Den Namen einer Sure: Kahf, Yasin, Rahman',
      'Einen bestimmten Vers: 2:255 oder 36 1',
      'Ein Thema nach Bedeutung: wechsle zu „Nach Bedeutung“',
    ],
  },
  words: {
    title: 'Der Koran in Zahlen',
    subtitle:
      'Wie oft kommt ein Wort im Koran vor, in welchen Suren, in mekkanischen oder medinensischen? Gib ein Wort ein oder vergleiche zwei, mit einem Klick.',
    tryOne: 'Probier ein Beispiel:',
    examples: 'Beispiele',
    inputLabel: 'Wort zum Zählen',
    placeholder: 'Ein Wort (z. B. mercy, الله, milost)',
    compareLabel: 'Wort zum Vergleichen',
    comparePlaceholder: 'Ein zweites Wort zum Vergleichen',
    wordA: 'Erstes Wort',
    wordB: 'Zweites Wort',
    addCompare: 'Mit einem anderen Wort vergleichen',
    removeCompare: 'Vergleich entfernen',
    count: 'Zählen',
    langLabel: 'Sprache des Textes',
    langBs: 'Bosnisch',
    langEn: 'Englisch',
    arabicDetected: 'Es wird im arabischen Text gezählt',
    modeLabel: 'Wie ein Wort gefunden wird',
    modeWord: 'Ganzes Wort',
    modePrefix: 'Beginnt mit',
    modeContains: 'Enthält',
    modeHint: {
      word: 'Zählt genau dieses Wort: „day“ zählt nicht „days“.',
      prefix: 'Zählt jedes Wort, das so beginnt: „merc“ zählt mercy, merciful, mercies…',
      contains: 'Zählt Wörter, die es enthalten: Das arabische „الله“ zählt auch „والله“, „بالله“…',
    },
    occurrences: '{n}-mal | {n}-mal',
    inAyahs: 'in {ayahs} Versen, {surahs} Suren',
    revelationSplit: 'Mekkanische Suren {meccan} %, medinensische {medinan} %',
    firstSeen: 'Zuerst',
    lastSeen: 'Zuletzt',
    topSurahs: 'Am häufigsten in',
    equal: '„{a}“ und „{b}“ werden gleich oft erwähnt, jeweils {n}-mal.',
    nearlyEqual: '„{a}“ und „{b}“ werden fast gleich oft erwähnt: {x}- und {y}-mal.',
    ratio: '„{more}“ wird {ratio}× so oft erwähnt wie „{less}“.',
    chartTitle: 'Über die 114 Suren',
    chartHint: 'Eine Säule pro Sure, in der Reihenfolge des Mushaf. Klicke auf eine für Details.',
    chartLabel: 'Vorkommen pro Sure',
    chartCaption: 'Säulendiagramm: eine Säule für jede der 114 Suren; die Höhe zeigt die Zahl der Vorkommen.',
    openSurah: 'Sure öffnen',
    noneTitle: 'Keine Vorkommen',
    noneBody: 'Übersetzungen geben denselben Gedanken oft mit anderen Worten wieder. Versuch es mit „Beginnt mit“ oder „Enthält“, einem Synonym oder dem arabischen Wort, denn maßgeblich ist der arabische Text.',
    ayahsTitle: 'Verse',
    method:
      'Wir zählen Wortformen im Text, ohne Vokalzeichen. Maßgeblich ist der arabische Text; Übersetzungen verwenden für denselben Gedanken verschiedene Wörter, daher weichen ihre Zahlen vom Arabischen ab.',
  },
  grammar: {
    title: 'Grammatik',
    root: 'Wurzel',
    lemma: 'Wörterbuchform',
    parts: 'Teile des Wortes',
    noRoot: 'Partikeln und Pronomen haben keine Wurzel.',
    rootCount: '{n}× im Koran',
    allOfRoot: 'Alle Wörter dieser Wurzel',
    person: '{n}. Person',
    gender: { M: 'maskulin', F: 'feminin' },
    number: { S: 'Singular', D: 'Dual', P: 'Plural' },
    form: 'Verbform {n}',
    passive: 'Passiv',
    definite: 'definit (mit ٱل)',
    indefinite: 'indefinit',
    family: 'aus der Wortfamilie „{word}“',
    tense: { PERF: 'Perfekt (Vergangenheit)', IMPF: 'Imperfekt (Gegenwart/Zukunft)', IMPV: 'Imperativ' },
    case: { NOM: 'Nominativ', ACC: 'Akkusativ', GEN: 'Genitiv' },
    mood: { IND: 'Indikativ', SUBJ: 'Subjunktiv', JUS: 'Jussiv' },
    class: {
      V: 'Verb',
      N: 'Nomen',
      PN: 'Eigenname',
      ADJ: 'Adjektiv',
      ACT_PCPL: 'aktives Partizip',
      PASS_PCPL: 'passives Partizip',
      VN: 'Verbalnomen (Masdar)',
      PRON: 'Pronomen',
      DEM: 'Demonstrativpronomen',
      REL: 'Relativpronomen',
      T: 'Zeitadverb',
      LOC: 'Ortsadverb',
      NV: 'verbale Interjektion',
      P: 'Partikel',
    },
    particle: {
      DET: 'bestimmter Artikel',
      CONJ: 'Konjunktion',
      REM: 'Wiederaufnahmepartikel',
      P: 'Präposition',
      NEG: 'Negationspartikel',
      EMPH: 'Betonungspartikel',
      INTG: 'Fragepartikel',
      VOC: 'Anredepartikel',
      FUT: 'Futurpartikel',
      CERT: 'Partikel der Gewissheit',
      RSLT: 'Folgepartikel',
      CAUS: 'Partikel des Grundes',
      SUB: 'unterordnende Konjunktion',
      COND: 'Bedingungspartikel',
      RES: 'Einschränkungspartikel',
      PRP: 'Partikel des Zwecks',
      CIRC: 'Umstandspartikel',
      EXP: 'Ausnahmepartikel',
      PREV: 'Hinderungspartikel',
      PRO: 'Verbotspartikel',
      RET: 'Berichtigungspartikel',
      SUP: 'Ergänzungspartikel',
      SUR: 'Überraschungspartikel',
      EXH: 'Aufforderungspartikel',
      EXL: 'Erklärungspartikel',
      EQ: 'Gleichsetzungspartikel',
      AMD: 'Korrekturpartikel',
      ANS: 'Antwortpartikel',
      AVR: 'Abwendungspartikel',
      COM: 'Komitativpartikel',
      INC: 'Einleitungspartikel',
      INT: 'Deutungspartikel',
      INL: 'Koranische Anfangsbuchstaben',
      ATT: 'Aufmerksamkeitspartikel',
      DIST: 'Entfernungsmarker',
      ADDR: 'Adressatenmarker',
      ACC: 'Akkusativpartikel',
    },
  },
  roots: {
    nav: 'Wurzeln',
    eyebrow: 'Der Wortschatz des Korans',
    title: 'Die Wurzeln der koranischen Wörter',
    subtitle:
      'Fast jedes arabische Wort wächst aus einer Wurzel von drei oder vier Buchstaben: Die Wurzel صبر ergibt Geduld, geduldig und geduldig sein. Wähle eine Wurzel und folge einem Gedanken durch den ganzen Koran.',
    factRoots: 'Wurzeln',
    factLemmas: 'Wörterbuchformen',
    factWords: 'Wörter mit ihrer Grammatik',
    lettersLabel: 'Wurzeln nach Anfangsbuchstabe',
    searchLabel: 'Wurzeln durchsuchen',
    searchPlaceholder: 'Eine Wurzel oder Bedeutung (z. B. رحم, knowledge, mercy)',
    count: '{n} Wurzeln',
    showing: '{shown} von {total} werden angezeigt',
    none: 'Keine Wurzel passt zu deiner Suche.',
    showMore: 'Mehr anzeigen',
    sortLabel: 'Sortieren',
    sortFrequent: 'Am häufigsten',
    sortAlpha: 'Alphabetisch',
    occurrences: '{n}× im Koran',
    words: '{n} Wort | {n} Wörter',
    pageTitle: 'Die Wurzel {root}',
    pageSubtitle: 'Alle Wörter, die aus dieser Wurzel gebildet sind, wo sie im Koran vorkommen und jeder Vers, in dem sie stehen.',
    lemmasTitle: 'Wörter aus dieser Wurzel',
    lemmasHint: 'Klicke auf ein Wort, um nur seine Verse zu sehen.',
    allLemmas: 'Alle Wörter',
    lemmaCol: 'Wort',
    classCol: 'Art',
    meaningCol: 'Bedeutung',
    countCol: 'Anzahl',
    filtered: 'Nur angezeigt: {lemma}',
    clearFilter: 'Ganze Wurzel anzeigen',
    chartTitle: 'Über die 114 Suren',
    ayahsTitle: 'Verse',
    back: 'Alle Wurzeln',
    notFound: 'Diese Wurzel kommt im Koran nicht vor.',
    whatTitle: 'Was ist eine Wurzel?',
    whatBody:
      'Im Arabischen steckt die Bedeutung in der Wurzel, meist drei Konsonanten; Vokale und Zusätze bilden daraus Wörter. Die Wurzel كتب ergibt kataba (er schrieb), kitāb (Buch), kātib (Schreiber) und maktūb (geschrieben). Wenn du einer Wurzel folgst, siehst du, wie der Koran einen Gedanken durch viele Wörter entfaltet.',
    methodTitle: 'Quelle und Methode',
    methodBody:
      'Wurzel, Wörterbuchform und Grammatik jedes Wortes stammen aus dem Quranic Arabic Corpus (University of Leeds), in dem jedes der 77.429 Wörter von Hand annotiert wurde. Die Bedeutungen der Wurzeln und Wörter hat eine KI aus den Wort-für-Wort-Bedeutungen der einzelnen Verse zusammengefasst; verstehe sie als Orientierung, nicht als Wörterbuch.',
    source: 'Grammatik: Quranic Arabic Corpus 0.4, Kais Dukes, University of Leeds (GNU GPL), mit Korrekturen aus mustafa0x/quran-morphology.',
    aiNote: 'Bedeutungen von KI zusammengefasst',
    teaser: 'Fast jedes arabische Wort wächst aus einer Wurzel von drei Buchstaben. Folge einer Wurzel durch den ganzen Koran: jedes daraus gebildete Wort, seine Bedeutung und jeder Vers.',
    cta: 'Wurzeln entdecken',
  },
  translations: {
    eyebrow: 'Weitere Übersetzungen',
    title: 'Übersetzungen im Vergleich',
    hint: 'Derselbe Vers in mehreren Übersetzungen. Wähle eine als Grundlage, um zu sehen, wo die anderen anders übersetzen.',
    compareWith: 'Unterschiede markieren zu',
    compareOff: 'Kein Vergleich',
    isBase: 'Vergleichsgrundlage',
    alike: '{n} % gleiche Wörter',
    legendAdded: 'anders',
    legendRemoved: 'ausgelassen',
    legendNote: 'Verglichen werden Übersetzungen in derselben Sprache, Wort für Wort.',
    footnote: 'Anmerkung {n}',
    notes: 'Anmerkungen des Übersetzers ({n})',
    extra: 'Weitere Übersetzungen unter jedem Vers',
    extraHint: 'Neben Korkut und Saheeh International, von QuranEnc.com.',
    lang: { bs: 'Bosanski', en: 'English', de: 'Deutsch', nl: 'Nederlands', fr: 'Français' },
    names: {
      'bubenheim': 'Bubenheim & Elyas (Deutsch)',
      'rowwad-de': 'Rowwad (Deutsch)',
      'rowwad-nl': 'Rowwad (Niederländisch)',
      rashid: 'Rachid Maach (Französisch)',
      'noor-fr': 'Noor International (Französisch)',
      korkut: 'Besim Korkut',
      mehanovic: 'Muhamed Mehanović',
      'rowwad-bs': 'Rowwad (Bosnisch)',
      saheeh: 'Saheeh International',
      'hilali-khan': 'Hilali & Khan',
      'rowwad-en': 'Rowwad (Englisch)',
    },
  },
  chronology: {
    nav: 'Chronologie',
    eyebrow: 'Reihenfolge der Offenbarung',
    title: 'Der Koran in der Reihenfolge seiner Offenbarung',
    subtitle:
      'Der Koran wurde nach und nach offenbart, über etwa 23 Jahre, und der Mushaf ordnet seine Suren nicht in dieser Reihenfolge. Hier stehen sie so, wie sie herabgesandt wurden: von den ersten Versen von Al-Alaq in Mekka bis zu den letzten Suren in Medina.',
    factYears: 'Jahre der Offenbarung',
    factMeccan: 'mekkanische Suren',
    factMedinan: 'medinensische Suren',
    timelineTitle: 'Alle Suren in der Reihenfolge der Offenbarung',
    timelineHint: 'Jede Säule ist eine Sure, so hoch, wie die Sure Wörter hat. Klicke auf eine Säule, um die Sure zu öffnen.',
    timelineInsight:
      'Die ersten offenbarten Suren sind kurz, rhythmisch und eindringlich. Im Lauf der Offenbarung werden sie länger, und nach der Hidschra nach Medina kommen die längsten Suren, mit den Gesetzen einer Gemeinschaft.',
    barHint: 'Höhe = Anzahl der Wörter',
    hijra: 'Hidschra (622)',
    revealedNth: 'als {n}. offenbart',
    ayahs: 'Verse',
    words: 'Wörter',
    ayahCount: '{n} Verse',
    chartLabel: 'Balkendiagramm: die 114 Suren in der Reihenfolge der Offenbarung; die Höhe zeigt die Zahl der Wörter, die Farbe die mekkanische oder medinensische Zeit.',
    chartCaption: 'Die Suren von links nach rechts in der Reihenfolge ihrer Offenbarung; die gestrichelte Linie ist die Hidschra.',
    compareTitle: 'Mekkanische und medinensische Suren',
    compareSubtitle: 'Ein Koran, zwei Zeiten: dreizehn Jahre, in denen die Menschen in Mekka gerufen wurden, und zehn Jahre, in denen in Medina eine Gemeinschaft entstand. Der Unterschied zeigt sich auch in den Zahlen.',
    metric: {
      surahs: 'Suren',
      ayahs: 'Verse',
      words: 'Wörter',
      wordsPerAyah: 'Wörter pro Vers (Mittelwert)',
      ayahsPerSurah: 'Verse pro Sure (Mittelwert)',
    },
    lengthInsight: 'Ein mekkanischer Vers hat im Schnitt {meccan} Wörter, ein medinensischer {medinan}. Die kurzen, dichten Verse aus Mekka werden in Medina länger und ausführlicher, weil sie Gesetze bringen.',
    distinctive: {
      meccan: 'Typisch für die mekkanischen Suren',
      medinan: 'Typisch für die medinensischen Suren',
    },
    distinctiveHint: 'Wurzeln, die eine Zeit weit häufiger verwendet als die andere. Zahlen: mekkanisch · medinensisch.',
    methodNote:
      'Methode: das Log-Odds-Verhältnis mit informativem Dirichlet-Prior (Monroe, Colaresi & Quinn, 2008) als z-Wert. Es misst nicht, wie häufig ein Wort ist, sondern wie unerwartet häufig es in einer Zeit ist, und bleibt bei seltenen Wörtern vorsichtig. Wurzeln aus dem Quranic Arabic Corpus.',
    listTitle: 'Die Suren in der Reihenfolge der Offenbarung',
    period: { meccan: 'Mekkanische Zeit · 1–86', medinan: 'Medinensische Zeit · 87–114' },
    aboutTitle: 'Über die Reihenfolge der Offenbarung',
    about1:
      'Die Reihenfolge ist die der ägyptischen Standardausgabe des Mushaf (al-Azhar, 1924), die sich auf Berichte der Gefährten und ihrer Schüler stützt. Sie wird am häufigsten zitiert, ist aber nicht die einzige: Die Gelehrten sind sich über die Stellung mancher Suren uneins, und manche Suren enthalten Verse aus beiden Zeiten.',
    about2:
      'Suren, die vor der Hidschra offenbart wurden, gelten als mekkanisch, jene danach als medinensisch, ganz gleich, wo ein Vers offenbart wurde. Die Jahre sind Näherungswerte: Die Offenbarung begann um 610, die Hidschra war 622, und die letzten Verse kamen 632.',
    source: 'Quellen: Reihenfolge der Offenbarung und Einteilung in mekkanisch und medinensisch, Tanzil Project (tanzil.net, CC BY 3.0); Wörter und Wurzeln, Quranic Arabic Corpus 0.4 (corpus.quran.com).',
    teaser: 'Die Suren in der Reihenfolge ihrer Offenbarung auf einem Zeitstrahl, und wie sich die mekkanischen und medinensischen Suren unterscheiden: in der Länge, im Rhythmus und in den Wörtern.',
    cta: 'Chronologie öffnen',
    mushafOrder: 'Reihenfolge des Mushaf',
    revelationOrder: 'Reihenfolge der Offenbarung',
    orderLabel: 'Reihenfolge der Suren',
  },
  app: {
    available: 'Kostenlos im',
    eyebrow: 'Die Deenly-App',
    title: 'Nimm den Koran mit',
    subtitle:
      'Im Web liest und studierst du. In der App lebt der Koran mit dir: Lerne auswendig mit einer KI, die deiner Rezitation zuhört, höre offline und verliere nie deine Stelle.',
    features: [
      { icon: 'solar:microphone-3-linear', title: 'Hifz mit KI', body: 'Rezitiere laut, und jedes Wort wird als richtig oder falsch markiert.' },
      { icon: 'solar:download-minimalistic-linear', title: 'Offline-Audio', body: 'Lade Suren herunter und höre sie überall.' },
      { icon: 'solar:bell-linear', title: 'Erinnerungen', body: 'Ein sanfter Hinweis morgens und abends, mit einem Vers des Tages.' },
      { icon: 'solar:cup-star-linear', title: 'Khatm & Auszeichnungen', body: 'Ein Leseplan und Meilensteine, die dich dranbleiben lassen.' },
    ],
  },
  footer: {
    title: 'Der Koran auf Deenly',
    body: 'Der Koran ist für alle offen, kostenlos und ohne Konto. Der Text und die Übersetzungen stammen aus den unten genannten vertrauenswürdigen Quellen.',
    arabic: 'Arabischer Text',
    audio: 'Audio',
    bs: 'Bosnische Übersetzung',
    en: 'Englische Übersetzung',
    links: 'Links',
  },
};
